<template>
  <!-- begin:: Footer -->
  <div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
    <div
      class="d-flex align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="text-dark">
        <span class="text-muted font-weight-bold mr-2">
          {{currentYear}}


        </span>
        <!-- href="https://www.argos-solutions.io" -->
        <a target="_blank"
            class="text-dark-75 text-hover-primary">
          Argos
        </a>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
export default {
  name: "KTFooter",

  data() {
    return {
      today : new Date(),
    }

  },

  filters : {

  },
  computed: {
    supportUrl() {
      const locale = this.$i18n.locale;
      return locale === 'ko'
          ? 'https://support.argosidentity.com/hc/ko/requests/new'
          : 'https://support.argosidentity.com/hc/en-us/requests/new';
    },
    ...mapGetters(["layoutConfig"]),

    currentYear() {
      return new Date().getFullYear();
    },


    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  },

  mounted() {
    console.log( "thismoment::", this.$moment( new Date() ).format( "YYYY" ))
  }
};
</script>
